import { render, staticRenderFns } from "./dialogDetail2.vue?vue&type=template&id=a847775e&scoped=true&"
import script from "./dialogDetail2.vue?vue&type=script&lang=ts&"
export * from "./dialogDetail2.vue?vue&type=script&lang=ts&"
import style0 from "./dialogDetail2.vue?vue&type=style&index=0&id=a847775e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a847775e",
  null
  
)

export default component.exports